import axios from './axiosInstances/axiosInstance';

export const getProductsMenu = (restaurantId) => {
  return axios.get(`/restaurants/${restaurantId}/products`);
};
